import Chat from '.'
import List from './List'

const routes = [
	{
		path: '/chat',
		component: Chat,
		children: [
			{
				path: [
					'/',
					'/message/:messageId',
					'/:channelId',
					'/:channelId/message/:messageId',
				],
				component: List,
			},
		],
	},
]

export default routes
